<mat-accordion>
  <mat-expansion-panel [expanded]="step === 0" (afterExpand)="step = 0">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span i18n>Optical Closures Applied on the Network</span>
        <mat-error *ngIf="appliedForm.invalid">
          <mat-icon>error</mat-icon>
        </mat-error>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <app-applied-form i18n-title title="Optical closures" [formArray]="appliedForm"
      [types]="parameters.feeding_box_types" [min]="1">
    </app-applied-form>

    <app-applied-form *ngIf="!isHorizontalUnbalanced" i18n-title
      title="Optical termination closure for horizontal properties" [formArray]="appliedForm"
      [types]="parameters.attendance_box_types_horiz" [min]="1">
    </app-applied-form>

    <app-applied-form i18n-title title="External closure for serving vertical collective properties"
      [formArray]="appliedForm" [types]="parameters.attendance_box_types_vert" [min]="1">
    </app-applied-form>

    <app-applied-form i18n-title title="External optical closure for serving horizontal collective properties"
      [formArray]="appliedForm" [types]="parameters.attendance_box_types_horiz_collective" [min]="1">
    </app-applied-form>

    <app-applied-form *ngIf="hasUnbalanced" i18n-title title="Optical closure for bus connection"
      [formArray]="appliedForm" [types]="parameters.feeding_box_bus_types" [min]="1">
    </app-applied-form>

    <mat-action-row>
      <button class="action-button" mat-stroked-button (click)="step = 1" [disabled]="appliedForm.invalid"
        i18n>CONTINUE</button>
    </mat-action-row>

  </mat-expansion-panel>

  <mat-expansion-panel [disabled]="appliedForm.invalid" [expanded]="step === 2" (afterExpand)="step = 2">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span i18n>Closure Specifications</span>
        <mat-error *ngIf="specificationForm.invalid">
          <mat-icon>error</mat-icon>
        </mat-error>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-accordion>

      <app-specification-form i18n-title title="Optical Closure" [formArray]="specificationForm"
        [types]="parameters.feeding_box_types" [fields]="['name', 'max_splitters', 'cable_ports', 'max_fusions']">
      </app-specification-form>

      <app-specification-form *ngIf="!isHorizontalUnbalanced" i18n-title
        title="Optical termination closure for horizontal properties" [formArray]="specificationForm"
        [types]="parameters.attendance_box_types_horiz"
        [fields]="['name', 'max_splitters', 'cable_ports', 'max_fusions', 'customer_ports']">
      </app-specification-form>

      <app-specification-form i18n-title title="External closure for serving vertical collective properties"
        [formArray]="specificationForm" [types]="parameters.attendance_box_types_vert"
        [fields]="['name', 'cable_ports', 'max_fusions']">
      </app-specification-form>

      <app-specification-form i18n-title title="External optical closure for serving horizontal collective properties"
        [formArray]="specificationForm" [types]="parameters.attendance_box_types_horiz_collective"
        [fields]="['name', 'cable_ports', 'max_fusions']">
      </app-specification-form>

      <app-specification-form *ngIf="hasUnbalanced" i18n-title title="Optical closure for bus connection"
        [formArray]="specificationForm" [types]="parameters.feeding_box_bus_types"
        [fields]="['name', 'max_splitters', 'cable_ports', 'max_fusions', 'bus_ports']">
      </app-specification-form>

      <mat-action-row>
        <button class="action-button" mat-stroked-button (click)="step = 3" [disabled]="specificationForm.invalid"
          i18n>CONTINUE</button>
      </mat-action-row>

    </mat-accordion>

  </mat-expansion-panel>

</mat-accordion>
